import { render, staticRenderFns } from "./member-name-native.vue?vue&type=template&id=3c10976a&"
import script from "./member-name-native.ts?vue&type=script&lang=js&"
export * from "./member-name-native.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports